import { t } from '@lingui/macro'
import { forwardRef, Ref } from 'react'

import { InputProps } from '../Input/input-types'
import { InputBase } from '../Input/InputBase'

const pattern = /^(19|20)\d{2}-(0[1-9]|1[0-2])-(0[1-9]|1\d|2\d|3[01])$/

export const validateDate = (value?: string) =>
    value
        ? !pattern.test(value)
            ? t({
                  id: 'core.dateInput.invalidError',
                  message: `Enter a valid date`,
              })
            : undefined
        : undefined

function Date(props: InputProps, ref: Ref<HTMLInputElement>) {
    return (
        <InputBase {...props} ref={ref} type="date" placeholder="yyyy-mm-dd" />
    )
}

export const DateInput = forwardRef(Date)
